import React from 'react';
import { get_offline_item_ids } from "./AuthProvider";

const Offtop = () => {
  return (
    <div>
      <h4>1. QRコードスキャン(オフライン)</h4>
      <a href="/offscan/">
        スキャンする
      </a>
      <br />
      ※スキャンした備蓄品ID は，出庫待ち備蓄品一覧に追加されます。<br />
      ※端末がオフライン(圏外) でもスキャンが可能です。<br />
      <br />
      <br />
      <br />

      <h4>2. 出庫待ち備蓄品一覧</h4>
      {get_offline_item_ids().length > 0 ? (
        <div>
          <ul>
            {get_offline_item_ids().map((item_id) => (
              <li key={item_id}>備蓄品ID : {item_id}</li>
            ))}
          </ul>
          <a href="/offout/">
            出庫する
          </a>
          <br />
          ※ 端末がオンラインのときに出庫してください。<br />
        </div>
      ) : (
        <div>
          なし
        </div>
      )}
    </div>
  );
};

export default Offtop;
